import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { AbstractVisual } from "./AbstractVisual";

const seedFrom = (slug = "") => slug.split("").reduce((a, c) => a + c.charCodeAt(0), 0);

export const ExperienceCard = ({ item, type = "experiences", index = 0, hideStatus = false }) => {
  const hue = item.hue ?? 222;
  return (
    <Link
      to={`/${type}/${item.slug}`}
      data-testid={`${type}-card-${item.slug}`}
      className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[#09090C] aspect-[3/4] flex flex-col justify-end p-7 poster-sheen hover:-translate-y-2 hover:border-white/25 hover:shadow-[0_24px_80px_rgba(0,0,0,0.6)] transition-all duration-500"
    >
      <AbstractVisual hue={hue} seed={seedFrom(item.slug)} />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
      <div className="absolute top-5 left-5 flex items-center gap-2">
        <span
          className="text-[10px] font-mono uppercase tracking-[0.18em] px-3 py-1.5 rounded-full border border-white/15 backdrop-blur-md bg-black/30"
        >
          {item.category || "VR Attraction"}
        </span>
        {item.status && !hideStatus && (
          <span className="text-[10px] font-mono uppercase tracking-[0.18em] px-3 py-1.5 rounded-full text-black bg-white/90">
            {item.status}
          </span>
        )}
      </div>
      <div className="relative">
        <p className="text-[11px] font-mono text-zinc-400 mb-2">{String(index + 1).padStart(2, "0")}</p>
        <h3 className="font-serif text-2xl md:text-3xl leading-tight mb-2">{item.name}</h3>
        <p className="text-sm text-zinc-400 font-light leading-relaxed line-clamp-2">{item.tagline}</p>
      </div>
      <div className="absolute top-5 right-5 w-9 h-9 rounded-full border border-white/15 backdrop-blur-md bg-black/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
        <ArrowUpRight size={15} />
      </div>
    </Link>
  );
};
